import { DETAIL_PROMO, INITIAL_PROMO } from "./types";

const initiate = {
    promos: [],
    detail: null,
}

const PromoReducer = (state = initiate, action) => {
    switch (action.type) {
        case INITIAL_PROMO:
            return {
                ...state,
                ...action.payload,
            };
        case DETAIL_PROMO:
            return {
                ...state,
                ...action.payload,
            };
        default:
            return state;
    }
}

export default PromoReducer;